var _defs, _g, _g2, _rect, _path, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _g3, _line, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwaremedida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-label": "Desarrollo de software a la medida",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "whiteHalo",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: 2,
    in: "SourceAlpha",
    result: "dilated"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    floodOpacity: 1,
    result: "haloColor"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "haloColor",
    in2: "dilated",
    operator: "in",
    result: "halo"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "halo"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3a86d8",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 60,
    x2: 48,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 100,
    x2: 48,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 140,
    x2: 48,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 60,
    x2: 218,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 100,
    x2: 218,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 140,
    x2: 218,
    y2: 140
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#3a86d8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 100,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 140,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 60,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 100,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 140,
    r: 3.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 40,
    height: 6,
    rx: 2,
    fill: "#1e3a8a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 150 L128 150 L132 160 L108 160 Z",
    fill: "#2e5bba"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 136,
    height: 112,
    rx: 8,
    fill: "#1e3a8a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 120,
    height: 88,
    rx: 3,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 120,
    height: 14,
    fill: "#bfe0f5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 55,
    r: 2.4,
    fill: "#2e5bba"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 55,
    r: 2.4,
    fill: "#3a86d8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 55,
    r: 2.4,
    fill: "#42a5e0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2e5bba",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "92,85 80,100 92,115"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148,85 160,100 148,115"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 82,
    x2: 108,
    y2: 118,
    stroke: "#3a86d8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,40) scale(1.2)",
    filter: "url(#whiteHalo)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#42a5e0",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -22 -12 A 25 25 0 0 1 22 -12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22 12 A 25 25 0 0 1 -22 12"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "26,-5 26,-14 19,-10",
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-26,5 -26,14 -19,10",
    fill: "#42a5e0"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#42a5e0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -11.5,
    width: 3,
    height: 4,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 7.5,
    width: 3,
    height: 4,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -1.5,
    width: 4,
    height: 3,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: -1.5,
    width: 4,
    height: 3,
    rx: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -11.5,
    width: 3,
    height: 4,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 7.5,
    width: 3,
    height: 4,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -1.5,
    width: 4,
    height: 3,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: -1.5,
    width: 4,
    height: 3,
    rx: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    r: 8
  })), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15,-5 16,6 34,-8",
    fill: "none",
    stroke: "#1e3a8a",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15,-5 16,6 34,-8",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 H18 V-6 a5 5 0 0 1 10 0 V0 H40 V14 H46 a5 5 0 0 1 0 10 H40 V36 H0 V24 H-6 a5 5 0 0 1 0 -10 H0 Z",
    fill: "#2e5bba",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinejoin: "round",
    paintOrder: "stroke fill"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,130)",
    filter: "url(#whiteHalo)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -17,
    width: 12,
    height: 9,
    rx: 1.5,
    fill: "#2e5bba"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#2e5bba",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -8,
    x2: 0,
    y2: -3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -9,
    y1: -3,
    x2: 9,
    y2: -3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -9,
    y1: -3,
    x2: -9,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: -3,
    x2: 9,
    y2: 3
  })), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 3,
    width: 12,
    height: 9,
    rx: 1.5,
    fill: "#3a86d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 9,
    rx: 1.5,
    fill: "#42a5e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwaremedida);
export default __webpack_public_path__ + "static/media/softwaremedida.880bb86cd436c29f9229a885f4d4efcd.svg";
export { ForwardRef as ReactComponent };